import React from 'react';
import DocumentHead from 'components/DocumentHead';

import useScrollToTop from 'hooks/useScrollToTop';
import InfluencerForm from 'components/signUp/InfluencerForm';

const InfluencerSignUp = () => {
  useScrollToTop();

  return (
    <>
      <DocumentHead>
        <title>Influencer | GigSocial</title>
      </DocumentHead>
      <InfluencerForm />
    </>
  );
};

export default InfluencerSignUp;
